import React from "react";

export default function SettingsPanel({ title, children }) {
  return (
    <div className="settings-panel">
      <div className="settings-panel-header">{title}</div>

      <div className="settings-panel-body">{children}</div>
    </div>
  );
}
